import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type ActionAttachmentUrlsFragment = (
  { __typename: 'Card' }
  & Pick<Types.Card, 'id'>
  & { attachments: Array<(
    { __typename: 'Attachment' }
    & Pick<Types.Attachment, 'url'>
  )> }
);

export const ActionAttachmentUrlsFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'ActionAttachmentUrls' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Card' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'attachments' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseActionAttachmentUrlsFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      ActionAttachmentUrlsFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseActionAttachmentUrlsFragmentResult
  extends Omit<Apollo.UseFragmentResult<ActionAttachmentUrlsFragment>, 'data'> {
  data?: ActionAttachmentUrlsFragment;
}

export const useActionAttachmentUrlsFragment = ({
  from,
  returnPartialData,
  ...options
}: UseActionAttachmentUrlsFragmentOptions): UseActionAttachmentUrlsFragmentResult => {
  const result = Apollo.useFragment<ActionAttachmentUrlsFragment>({
    ...options,
    fragment: ActionAttachmentUrlsFragmentDoc,
    fragmentName: 'ActionAttachmentUrls',
    from: {
      __typename: 'Card',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as ActionAttachmentUrlsFragment };
};
